import { Routine } from 'redux-saga-routines';
import {
  createEmailTemplateRoutine,
  fetchEmailTemplatesRoutine,
  getCandidateTemplateCodeRoutine,
  getReferenceTemplateCodeRoutine,
  updateEmailTemplateRoutine
} from '../../routines';
import { IEmailTemplate } from '../../../../common/models/email/IEmailTemplate';
import { map } from 'ramda';

export type EmailTemplatesState = {
  emailTemplates: IEmailTemplate[];
  defaultEmailTemplates: IEmailTemplate[];
  isLoading: boolean;
  candidateTemplateCode?: string;
  referenceTemplateCode?: string;
};

const initialState: EmailTemplatesState = {
  emailTemplates: [],
  defaultEmailTemplates: [],
  isLoading: false
};

export const emailTemplates = (
  state: EmailTemplatesState = initialState,
  { type, payload }: Routine<any>
): EmailTemplatesState => {
  switch (type) {
    case fetchEmailTemplatesRoutine.TRIGGER:
      return {
        ...state,
        isLoading: true
      };
    case fetchEmailTemplatesRoutine.SUCCESS:
      return {
        ...state,
        ...payload,
        isLoading: false
      };
    case fetchEmailTemplatesRoutine.FAILURE:
      return {
        ...state,
        isLoading: false
      };
    case updateEmailTemplateRoutine.SUCCESS:
    case createEmailTemplateRoutine.SUCCESS: {
      const templatesCopy = map(t => {
        if (t.type === payload.type) {
          return payload;
        }
        return t;
      }, state.emailTemplates);
      return {
        ...state,
        emailTemplates: templatesCopy,
        isLoading: false
      };
    }
    case getCandidateTemplateCodeRoutine.SUCCESS:
      return {
        ...state,
        candidateTemplateCode: payload
      };
    case getReferenceTemplateCodeRoutine.SUCCESS:
      return {
        ...state,
        referenceTemplateCode: payload
      };
    default:
      return state;
  }
};
